import React, { useState } from 'react';
import { BookOpenIcon, PenToolIcon, BookMarkedIcon, FileTextIcon, ScrollTextIcon, LibraryIcon, GiftIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
interface AccordionCardProps {
  title: string;
  topics: string;
  includes: string;
  icon: React.ReactNode;
  iconBg: string;
  isOpen: boolean;
  onToggle: () => void;
}
function AccordionCard({
  title,
  topics,
  includes,
  icon,
  iconBg,
  isOpen,
  onToggle
}: AccordionCardProps) {
  return <div className={`bg-[#1a1512] border rounded-xl overflow-hidden transition-all duration-300 shadow-sm group cursor-pointer ${isOpen ? 'border-[#D4A843] ring-1 ring-[#D4A843]/30' : 'border-gray-700 hover:border-[#D4A843]/50'}`} onClick={onToggle} data-id="element-255">
      <div className="p-3 sm:p-4" data-id="element-256">
        <div className="flex items-start gap-3 sm:gap-4" data-id="element-257">
          <div className={`${iconBg} w-10 h-10 sm:w-12 sm:h-12 rounded-lg flex items-center justify-center flex-shrink-0 transition-colors shadow-sm`} data-id="element-258">
            {icon}
          </div>
          <div className="flex-1 pt-1" data-id="element-259">
            <h3 className="text-sm sm:text-lg font-black text-white leading-tight" data-id="element-260">
              {title}
            </h3>
          </div>
          <div className="text-gray-400 mt-1" data-id="element-261">
            {isOpen ? <ChevronUpIcon size={20} className="text-[#D4A843]" data-id="element-262" /> : <ChevronDownIcon size={20} data-id="element-263" />}
          </div>
        </div>

        <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[300px] opacity-100 mt-2 sm:mt-3' : 'max-h-0 opacity-0'}`} data-id="element-264">
          <div className="h-px bg-gray-700 mb-2 sm:mb-3" data-id="element-265"></div>
          <div className="space-y-3" data-id="element-266">
            <div data-id="element-267">
              <p className="text-xs sm:text-sm text-gray-300 font-medium mb-1" data-id="element-268">
                <span className="text-[#D4A843] mr-1" data-id="element-269">✔</span>
                {topics}
              </p>
            </div>
            <div className="bg-[#121008] p-3 rounded-lg border border-gray-800" data-id="element-270">
              <p className="text-xs sm:text-sm text-gray-400 font-bold uppercase tracking-wider mb-1" data-id="element-271">
                Incluye:
              </p>
              <p className="text-xs sm:text-sm text-gray-200 font-medium" data-id="element-272">
                • {includes}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}
export function QueIncluye() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="que-incluye" className="py-5 sm:py-14 bg-transparent relative overflow-hidden border-t border-gray-800" data-id="element-273">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5" data-id="element-274">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-[#D4A843] rounded-full blur-3xl" data-id="element-275"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-[#B8922E] rounded-full blur-3xl" data-id="element-276"></div>
      </div>

      <div className="max-w-4xl mx-auto px-3 sm:px-6 relative z-10" data-id="element-277">
        <div className="text-center mb-4 sm:mb-8" data-id="element-278">
          <span className="text-gray-400 font-bold tracking-widest uppercase text-xs sm:text-sm mb-2 block" data-id="element-279">
            📦 ¿QUÉ INCLUYE EL KIT?
          </span>
          <h2 className="text-xl sm:text-4xl md:text-5xl font-black text-white mb-2 sm:mb-4" data-id="element-280">
            Todo el material organizado en{' '}
            <span className="text-[#D4A843]" data-id="element-281">6 tomos prácticos</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4 mb-4 sm:mb-8" data-id="element-282">
          <AccordionCard title="📘 TOMO 1 — Comprensión Lectora" topics="Tipos de textos: narrativo, expositivo y argumentativo | Estrategias de comprensión | Identificación de ideas principales | Interpretación y análisis" includes="actividades guiadas • textos para trabajar en clase • preguntas de comprensión • evaluaciones listas" icon={<BookOpenIcon className="text-blue-400 w-5 h-5 sm:w-6 sm:h-6" data-id="element-284" />} iconBg="bg-blue-900/30" isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-283" />
          <AccordionCard title="📗 TOMO 2 — Producción Escrita" topics="Proceso de escritura paso a paso | Coherencia y cohesión | Tipos de textos (narrativo, descriptivo, argumentativo) | Redacción y revisión" includes="talleres de escritura • actividades guiadas • ejemplos reales • corrección de textos" icon={<PenToolIcon className="text-[#E8C547] w-5 h-5 sm:w-6 sm:h-6" data-id="element-286" />} iconBg="bg-[#D4A843]/20" isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-285" />
          <AccordionCard title="📙 TOMO 3 — Gramática Aplicada" topics="Clases de palabras | Funciones sintácticas | Análisis de oraciones | Uso del lenguaje en contexto" includes="ejercicios prácticos • análisis sintáctico • actividades progresivas • evaluaciones listas" icon={<BookMarkedIcon className="text-[#D4A843] w-5 h-5 sm:w-6 sm:h-6" data-id="element-288" />} iconBg="bg-[#9A7B24]/30" isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-287" />
          <AccordionCard title="📕 TOMO 4 — Literatura" topics="Géneros literarios | Narrativa, poesía y teatro | Elementos del relato | Recursos literarios" includes="textos para trabajar • análisis guiado • actividades interpretativas • guías de lectura" icon={<FileTextIcon className="text-red-400 w-5 h-5 sm:w-6 sm:h-6" data-id="element-290" />} iconBg="bg-red-900/30" isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-289" />
          <AccordionCard title="📒 TOMO 5 — Ortografía y Normativa" topics="Reglas ortográficas clave | Uso correcto de tildes | Signos de puntuación | Errores frecuentes" includes="ejercicios prácticos • actividades de corrección • aplicación en textos • evaluaciones" icon={<ScrollTextIcon className="text-yellow-400 w-5 h-5 sm:w-6 sm:h-6" data-id="element-292" />} iconBg="bg-yellow-900/30" isOpen={openIndex === 4} onToggle={() => handleToggle(4)} data-id="element-291" />
          <AccordionCard title="📓 TOMO 6 — Evaluación y TPs" topics="Evaluaciones listas por tema | Trabajos prácticos completos | Rúbricas de corrección | Evaluaciones integradoras" includes="evaluaciones listas para usar • recuperatorios • proyectos prácticos • instrumentos de evaluación" icon={<LibraryIcon className="text-purple-400 w-5 h-5 sm:w-6 sm:h-6" data-id="element-294" />} iconBg="bg-purple-900/30" isOpen={openIndex === 5} onToggle={() => handleToggle(5)} data-id="element-293" />
        </div>

        <div className="text-center mt-4 sm:mt-8" data-id="element-295">
          <div className="inline-block bg-[#D4A843]/10 border-2 border-[#D4A843] rounded-xl px-4 sm:px-8 py-3 sm:py-4 shadow-[0_0_20px_rgba(212,168,67,0.1)]" data-id="element-296">
            <p className="text-base sm:text-2xl md:text-3xl font-black text-white leading-tight" data-id="element-297">
              📚 +360 páginas · 6 tomos
            </p>
            <p className="text-sm sm:text-lg font-bold text-[#E8C547] mt-1" data-id="element-298">
              Todo listo para usar durante el año
            </p>
          </div>
        </div>
      </div>
    </section>;
}